import { AlertIcon } from '@silo/ui';
import toast from 'react-hot-toast';

const notifyError = (msg?: string) => {
  const trimmedMessage = msg?.slice(0, 100);

  toast.custom((t) => (
    <div
      className={`${
        t.visible ? 'animate-enter' : 'animate-leave'
      } border-l-4 border-x-red-400 max-w-md w-full bg-shale-750 shadow-lg rounded-r-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
    >
      <div className="flex-1 w-0 p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0 pt-0.5 text-red-400">
            <AlertIcon />
          </div>
          <div className="flex-1 ml-3">
            <p className="text-base font-medium text-white">Error</p>
            <p className="mt-1 text-base text-shale-200">
              A system error has occured: {trimmedMessage && `${trimmedMessage} .`} Please contact us for assistance if
              the error persists.
            </p>
          </div>
        </div>
      </div>
      <div className="flex my-4 border-l border-shale-600">
        <button
          onClick={() => toast.dismiss(t.id)}
          className="flex items-center justify-center w-full p-4 text-sm font-semibold text-blue-300 border border-transparent rounded-none rounded-r-lg hover:text-text-blue-500"
        >
          Done
        </button>
      </div>
    </div>
  ));
};

export const notifyWarning = (title: string, message: string) => {
  toast.custom(
    (t) => (
      <div
        className={`${
          t.visible ? 'animate-enter' : 'animate-leave'
        } border-l-4 border-x-amber-300 max-w-md w-full bg-shale-750 shadow-lg rounded-r-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
      >
        <div className="flex-1 w-0 p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0 pt-0.5 text-amber-300">
              <AlertIcon />
            </div>
            <div className="flex-1 ml-2">
              <p className="font-medium text-white">{title}</p>
              <p className="mt-2 text-shale-200">{message}</p>
            </div>
          </div>
        </div>
      </div>
      // 6 seconds
    ),
    { duration: 6000 }
  );
};

const useNotify = () => {
  const notify = (msg: string) => msg && toast(msg);

  return { notifyError, notify, notifyWarning };
};

export default useNotify;
